import { IPaginationQuery } from './IPaginationQuery';

// pageNumber is 1 lower in a request than it is in the query
//  The data grid is 1 based in the UI.
export type IPaginationQueryRequest = IPaginationQuery;

export const convertFromIPaginationQueryToIPaginationQueryRequest = (
  query: IPaginationQuery
): IPaginationQueryRequest => ({
  pageNumber: query.pageNumber ? query.pageNumber - 1 : undefined,
  pageSize: query.pageSize,
});
